<script setup lang="ts">
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import type { Elemental } from '~~/src/types/elemental'

const { elemental, route } = defineProps<{
  elemental: Elemental
  route: string
}>()

const { push } = useRouter()
const open = () => {
  push(`/${route}/${elemental.url}?view_type=feed`)
}
defineOptions({
  name: 'OpenElementalFeedOption',
})
</script>

<template>
  <MenuItem @select="open">
    <template #icon>
      <IconFeedView w-3 h-3 />
    </template>
    Open Feed View
  </MenuItem>
</template>
